import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconUseThis = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.573 26.091"
    {...props}
  >
    <g transform="translate(-63.952 0)">
      <g transform="translate(71.566 7.61)">
        <g transform="translate(0)">
          <path
            d="M225.168,160.36,214.3,149.489a.544.544,0,0,0-.928.385v15.053a.544.544,0,0,0,.878.428l2.759-2.158,2.409,4.336a.545.545,0,0,0,.72.222l3.261-1.631a.543.543,0,0,0,.232-.75l-2.269-4.084h3.425a.544.544,0,0,0,.385-.928Zm-4.733-.159a.545.545,0,0,0-.475.809l2.442,4.4-2.287,1.145-2.466-4.438a.543.543,0,0,0-.367-.27.517.517,0,0,0-.108-.011.539.539,0,0,0-.335.115l-2.383,1.863V151.186l9.016,9.016h-3.036Z"
            transform="translate(-213.368 -149.33)"
          />
        </g>
      </g>
      <g transform="translate(63.952 0)">
        <g transform="translate(0 0)">
          <path
            d="M79.724,5.238A8.154,8.154,0,1,0,68.786,15.6a.544.544,0,0,0,.442-.994,7.066,7.066,0,1,1,9.333-3.572.543.543,0,1,0,.993.442A8.1,8.1,0,0,0,79.724,5.238Z"
            transform="translate(-63.952 0)"
          />
        </g>
      </g>
      <g transform="translate(67.215 3.259)">
        <path
          d="M137.476,67.164a4.892,4.892,0,1,0-6.658,6.115.552.552,0,0,0,.228.05.544.544,0,0,0,.229-1.037,3.8,3.8,0,1,1,5.054-1.846.544.544,0,1,0,.987.459A4.865,4.865,0,0,0,137.476,67.164Z"
          transform="translate(-127.986 -63.948)"
        />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconUseThis)
